/* La Pepa · Pair-Gruppen (sections/lp-pair-groups.liquid)
 * Chips schalten Bandfarbe (--lp-pair-band, Übergang im CSS), sichtbares Karussell und die Kopf-Werkzeuge
 * („View all“, Pfeile) der aktiven Gruppe um. Tastatur: Pfeiltasten, Pos1/Ende im Tablist-Muster.
 * Versteckte Karussells brauchen nichts extra: <scroll-carousel> misst über seinen ResizeObserver neu,
 * sobald die Pane sichtbar wird (is-scrollable, Position).
 */
class LpPairGroups extends HTMLElement {
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.addEventListener('click', (event) => {
      const chip = event.target.closest('.lp-pair-groups__chip');
      if (chip && this.contains(chip)) this.select(chip);
    }, { signal });
    this.addEventListener('keydown', (event) => this.#onKeydown(event), { signal });
    // Theme-Editor: gewählten Gruppen-Block anzeigen
    this.addEventListener('shopify:block:select', (event) => {
      const chip = event.target.closest?.('.lp-pair-groups__chip');
      if (chip) this.select(chip, { focus: false });
    }, { signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  get chips() {
    return Array.from(this.querySelectorAll('.lp-pair-groups__chip'));
  }

  select(chip, { focus = false } = {}) {
    const key = chip.dataset.pane;
    if (chip.dataset.color) this.style.setProperty('--lp-pair-band', chip.dataset.color);

    this.chips.forEach((c) => {
      const active = c === chip;
      c.setAttribute('aria-selected', String(active));
      c.tabIndex = active ? 0 : -1;
    });
    this.querySelectorAll('.lp-pair-groups__pane').forEach((pane) => { pane.hidden = pane.dataset.pane !== key; });
    this.querySelectorAll('.lp-pair-groups__tools').forEach((tools) => { tools.hidden = tools.dataset.tools !== key; });

    chip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    if (focus) chip.focus();
  }

  #onKeydown(event) {
    const chips = this.chips;
    const index = chips.indexOf(event.target);
    if (index < 0) return;
    const rtl = getComputedStyle(this).direction === 'rtl';
    let next = null;
    if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
    else if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = chips.length - 1;
    if (next === null) return;
    event.preventDefault();
    this.select(chips[(next + chips.length) % chips.length], { focus: true });
  }
}

if (!customElements.get('lp-pair-groups')) customElements.define('lp-pair-groups', LpPairGroups);
